const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['note', [this, 'block_note']],
                    ['event_details', [this, 'block_event_details']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`heading_level`] = (((context.has(`heading_level`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`heading_level`) ? context.get(`heading_level`) : null), 3])) : (3));
                this.startOutputBuffer();
                this.traceableDisplayBlock(2, this.source)('note', context.clone(), blocks);
                context.proxy[`_note`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
`);
                this.startOutputBuffer();
                this.echo(`  `);
                this.traceableDisplayBlock(6, this.source)('event_details', context.clone(), blocks);
                context.proxy[`_event_details`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
<div class="c-event-summary`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`">
  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86`, `97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86`, 20, 7), new Map([[`reverse_markup`, true], [`datetime`, (context.has(`datetime`) ? context.get(`datetime`) : null)], [`note`, (context.has(`_note`) ? context.get(`_note`) : null)], [`event`, (context.has(`event`) ? context.get(`event`) : null)], [`href`, (context.has(`href`) ? context.get(`href`) : null)], [`heading_level`, (context.has(`heading_level`) ? context.get(`heading_level`) : null)], [`event_details`, (context.has(`_event_details`) ? context.get(`_event_details`) : null)]]), false, false, 20));
                this.echo(`</div>
`);
            }

            block_note(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.env.getFilter('escape').traceableCallable(2, this.source)(...[this.env, (context.has(`note`) ? context.get(`note`) : null), `html`, null, true]));
            }

            block_event_details(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.has(`location`) ? context.get(`location`) : null), `html`, null, true]));
                this.echo(`</p>
    <p>
      `);
                if (this.compare(this.env.getFilter('length').traceableCallable(9, this.source)(...[this.env, (context.has(`speakers`) ? context.get(`speakers`) : null)]), 1)) {
                    this.echo(`        Speaker:
      `);
                }
                else {
                    this.echo(`        Speakers:
      `);
                }
                this.echo(`      `);
                this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, this.env.getFilter('join').traceableCallable(14, this.source)(...[(context.has(`speakers`) ? context.get(`speakers`) : null), `, `]), `html`, null, true]));
                this.echo(`
    </p>
  `);
            }

            getTemplateName() {
                return `97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86`, ``);
            }
        }],
        [7, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86`, 20);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/calendar-date/calendar-date.twig`, new Map([[`datetime`, (context.has(`datetime`) ? context.get(`datetime`) : null)], [`note`, (context.has(`note`) ? context.get(`note`) : null)], [`class`, `c-event-summary__calendar-date`]]), false, false, 30));
                this.echo(`    `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      <h`);
                this.echo(this.env.getFilter('escape').traceableCallable(37, this.source)(...[this.env, (context.has(`heading_level`) ? context.get(`heading_level`) : null), `html`, null, true]));
                this.echo(`>
        <a
          href="`);
                this.echo(this.env.getFilter('escape').traceableCallable(39, this.source)(...[this.env, (context.has(`href`) ? context.get(`href`) : null), `html`, null, true]));
                this.echo(`"
          class="c-event-summary__link"
        >
          `);
                this.echo(this.env.getFilter('escape').traceableCallable(42, this.source)(...[this.env, (context.has(`event`) ? context.get(`event`) : null), `html`, null, true]));
                this.echo(`
        </a>
      </h`);
                this.echo(this.env.getFilter('escape').traceableCallable(44, this.source)(...[this.env, (context.has(`heading_level`) ? context.get(`heading_level`) : null), `html`, null, true]));
                this.echo(`>
      `);
                this.echo(this.env.getFilter('escape').traceableCallable(45, this.source)(...[this.env, (context.has(`event_details`) ? context.get(`event_details`) : null), `html`, null, true]));
                this.echo(`
    `);
            }

            getTemplateName() {
                return `97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86');

let template = env.loadTemplate('97cc5b2ecf451b45e33feef70ef221aed88a226eafc9ee8bc65ab1e75788dd86');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/event-summary/event-summary.twig", args: context }
     );
     return rendered;;
};